Namespace 'Customer.Views.Activity'

class Customer.Views.Activity.SubtypeCheckboxView extends Backbone.View
  template: JST['backbone/templates/customer/activity/content_type_filter/subtype_checkbox']
  className: 'checkbox inline no-indent'

  events:
    'change .subtype-selector-checkbox': 'onChange'

  initialize: ({subtype, isSelected}) ->
    @subtype = subtype
    @isSelected = isSelected
    @id = "checkbox-for-#{@subtype}"
    @label = if @_isGroupedByUser() then @_translatedType() else @_translatedSubtype()

  render: ->
    @$el.html @template
      inputId: "checkbox-input-#{@subtype}"
      subtype: @subtype
      label: @label
      checked: if @isSelected then 'checked' else ''
    @

  onChange: (event) ->
    @trigger('checkbok:change', event.target.checked)

  isChecked: ->
    $("checkbox-input-#{@subtype}").is(':checked')

  _isGroupedByUser: ->
    @subtype.endsWith '-user'

  _translatedType: ->
    type = new Common.SubtypeToTypeTranslator().translate @subtype
    I18n.t "social_accounts.providers.#{type}"

  _translatedSubtype: ->
    I18n.t "monitoring.arrival_alerts.subtypes.#{@subtype}"
